import React, { useState } from "react";
import '../../assets/css/style.css';
import Logo from '../../assets/img/logo.png';
import ListImage from '../../assets/img/list.svg';
import TegleIcon from '../../assets/img/nav.svg';
import Sidbar from './Sidebar';  
const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
      setIsOpen(!isOpen);
    };
    
  return (
    <div>
      <header className="app-header">
          <img src={ListImage} alt="لیست" />
          <div className="logo">
              <img src={Logo} alt="دان" />
          </div>
          <button className="menu-toggle" id="menuToggle">
              <img src={TegleIcon} onClick={toggleSidebar} alt="نوبار" />
          </button>
      </header>

      {/* ارسال isOpen و toggleSidebar به Sidbar */}
      <Sidbar isOpen={isOpen} toggleSidebar={toggleSidebar} />
    </div>
  );
};

export default Header;
